module.exports = "<app-deal-payroll-catalog></app-deal-payroll-catalog>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/admin/deal-payroll-catalog/deal-payroll-rates.component.html
// module id = ../../../../../src/app/content-page/admin/deal-payroll-catalog/deal-payroll-rates.component.html
// module chunks = main